var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"blog-post-link"},[_c('router-link',{attrs:{"to":_vm.path}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.date))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c0133328","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/blog/blog-post-link.vue
// module id = aJ+Y
// module chunks = 0